import moment from "moment/moment";
import React, { useState } from "react";
import { Modal, Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";
import { useLazyCouponsStatusQuery } from "../../redux/api/api";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

const CouponPages = ({
  getCouponList,
  searchCoupon,
  setCouponPage,
  getCouponTransactionList,
  CouponCount,
  listCoupon,
  paginationCoupon,
  rowCoupon,
  type,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [btn, setBtn] = useState(false);

  const [couponsStatusApi] = useLazyCouponsStatusQuery();

  const handlePageChange = (selectedObject) => {
    setCouponPage(selectedObject.selected + 1);
  };

  const statusChange = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    couponsStatusApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          if (res?.message?.includes("expired")) {
            Swal.fire({
              text: res?.message,
              icon: "info",
            });
          } else {
            Swal.fire({
              text: res?.message,
              icon: "success",
            });
          }

          getCouponList("", "");
          getCouponTransactionList("", "");
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationCoupon?.total}
          </label>
        </div>
      </Row>
      <Row sm={12} md={12}>
        <div className="d-flex ac-je block-header add-btn">
          <button className="f1 d-flex" onClick={() => navigate("/coupon")}>
            <AddIcon />
            Add Coupon
          </button>
        </div>
      </Row>
      <div className="d-flex ac-jb">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) => getCouponList(searchCoupon, e.target.value)}
            value={rowCoupon}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="mb-2">
          <input
            className="form-control bg-white"
            placeholder="Eg: Coupon code"
            style={{ width: "300px" }}
            onChange={(e) => getCouponList(e.target.value, rowCoupon)}
            value={searchCoupon}
          />
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Coupon Code</th>
              <th>Validity</th>
              <th>Type</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {listCoupon?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationCoupon?.current_page - 1) * rowCoupon + ind + 1}
                  </td>
                  <td>{item?.coupon_code}</td>
                  <td>{item?.validity}</td>
                  <td>
                    {item?.type == 1
                      ? "Register Coupon"
                      : item?.type == 2
                      ? "Refferal Coupon"
                      : item?.type == 3
                      ? "Upi Payment Coupon"
                      : item?.type == 4
                      ? "Birthday Coupon"
                      : item?.type == 5
                      ? "Monthly Booking Coupon"
                      : item?.type == 6
                      ? "Influencer Coupon"
                      : "Exciting Offer"}
                  </td>
                  <td>
                    {" "}
                    <button
                      className={`${
                        item?.status == 1 ? "btn-success" : "btn-danger"
                      } px-2 py-1 rounded-1 border-0 text-white`}
                      onClick={() => statusChange(item?.id)}
                      disabled={btn}
                    >
                      {item?.status == 1
                        ? "Active"
                        : item?.status == 2
                        ? "Expired"
                        : "Deactive"}
                    </button>
                  </td>
                  <td>
                    <div className="d-flex ac-jc gap-2">
                      <button
                        className="cust-btn"
                        onClick={() =>
                          navigate("/coupon", {
                            state: { type: "edit", data: item },
                          })
                        }
                      >
                        <img src={editIcon} className="edit-btn" />
                      </button>
                      <button
                        className="cust-btn"
                        onClick={() =>
                          navigate("/coupon", {
                            state: { type: "edit", data: item },
                          })
                        }
                      >
                        <img src={viewIcon} className="edit-btn" />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={CouponCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default CouponPages;
